import { call, takeLatest } from '@redux-saga/core/effects'
import { put, select } from 'redux-saga/effects'
import { getSelectedItem } from '../selectors'
import { IItem } from '../store/timeline.types'
import { TimelineConstants } from '../store/timeline.constants'
import { getPcrIdSelector } from '../../home/selectors'
import { IPcr } from '../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../user/selectors'
import { setState } from '../../addMedicationAdministered/store/addMedicationAdministered.actions'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* setMedicationAdministeredItem() {
  const selectedItem: IItem = yield select(getSelectedItem)
  const pcrID: string = yield select(getPcrIdSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  if (pcrID) {
    try {
      if (selectedItem) {
        const pcrDocsService = new PcrDocsService(serviceId)
        const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
        const maState = pcrDoc.patient.medicationAdministeredStateList?.find((maState) => {
          if (selectedItem.labelHeader) {
            maState.time = selectedItem?.labelHeader
          }
          return maState.key === selectedItem.key
        })
        yield put(setState(maState))
      }
    } catch (e) {
      yield put(throwPcrException(`setMedicationAdministeredItem() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}

export function* setMedicationAdministeredItemSaga() {
  yield takeLatest(
    [TimelineConstants.SET_ADD_MEDICATION_ADMINISTERED_ITEM],
    performWithMutexHOG,
    setMedicationAdministeredItem
  )
}
